import { gql } from "@apollo/client";

const CREATE_SURVEY_RESPONSE = gql`
  mutation SurveyResponse($input: SurveyResponseInput!) {
    surveyResponse(input: $input) {
      surveyResponse {
        surveyAnswer {
          id
          answerText
        }
        surveyQuestion {
          id
          questionText
          questionType
        }
        student {
          givenName
          familyName
          email
        }
        customAnswer
      }
    }
  }
`;

export default CREATE_SURVEY_RESPONSE;
